import { Paper } from '@comet/blocks';
import { useLocation } from '@comet/router';
import { CreateSecretForm } from './CreateSecret.Form';
import { ErrorPage } from '@comet/pages/ErrorPage';
import { useProjectPermissions } from '@comet/hooks/useProjectPermission';

export const CreateSecret = () => {
  const location = useLocation();
  const stateData = location.state;

  const { hasManageProjectSettingsAccess } = useProjectPermissions();

  if (!hasManageProjectSettingsAccess) {
    return <ErrorPage />;
  }

  return (
    <Paper size="medium">
      <CreateSecretForm environmentId={stateData.envId} />
    </Paper>
  );
};
